import placeholder from '../assets/placeholder.png';

function Image(props) {
  const { imgSrc, style, alt } = props;

  const addDefaultSrc = (e) => {
    if (e.target.src !== placeholder) {
      e.target.src = placeholder;
    }
  };

  return (
    <img
      onError={addDefaultSrc}
      src={imgSrc}
      style={style}
      alt={alt}
    />
  );
};

export default Image;